import { ScrollReveal } from "@/hooks/useScrollReveal";
import Watermark from "@/components/base/Watermark";

const directions = [
  {
    icon: "ri-heart-pulse-line",
    title: "醫療保健",
    description: "出版與健康、醫療及保健知識相關的閱讀內容。",
  },
  {
    icon: "ri-flask-line",
    title: "研究",
    description: "出版與研究知識及研究相關主題有關的專業書籍。",
  },
  {
    icon: "ri-book-open-line",
    title: "論文相關專業書籍",
    description: "提供論文與專業知識相關的出版閱讀內容。",
  },
];

export default function BrandPrinciples() {
  return (
    <section className="min-h-[100svh] flex items-center bg-background-50">
      <Watermark />
      <div className="mx-auto px-6 md:px-10 py-16 md:py-24 max-w-[1120px] w-full">
        <ScrollReveal>
          <div className="flex flex-col lg:flex-row lg:gap-16 mb-14 md:mb-20">
            <div className="lg:w-[30%] flex-shrink-0 mb-6 lg:mb-0">
              <p className="text-xs tracking-[0.2em] uppercase text-foreground-400 font-medium">
                出版方向
              </p>
            </div>
            <div className="lg:w-[70%]">
              <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 leading-tight">
                主要出版方向
              </h2>
              <p className="text-sm text-foreground-500 mt-4 leading-relaxed max-w-lg">
                崧燁文化聚焦醫療保健、研究與論文相關專業書籍，透過出版整理專業知識，提供讀者進一步閱讀與理解相關議題的內容。
              </p>
            </div>
          </div>
        </ScrollReveal>

        {/* Three directions */}
        <div className="lg:ml-[30%] lg:pl-16">
          <div className="space-y-6">
            {directions.map((d, i) => (
              <ScrollReveal key={d.title} delay={i * 120}>
                <div className="group flex items-start gap-5 p-5 md:p-6 bg-background-50 border border-background-200/70 hover:border-background-300/60 transition-colors">
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center">
                    <i className={`${d.icon} text-xl text-foreground-900`}></i>
                  </div>
                  <div>
                    <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-1.5">
                      {d.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {d.description}
                    </p>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>

          {/* Bottom note */}
          <ScrollReveal delay={400}>
            <p className="text-xs text-foreground-400 mt-10 leading-relaxed">
              以上出版方向屬於知識閱讀內容，不代表崧燁文化提供醫療診斷、研究代做、論文代寫或其他專業代辦服務。
            </p>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}